import { createFileRoute, redirect } from "@tanstack/react-router";

// Backward-compat redirect — preserves external links / bookmarks.
export const Route = createFileRoute("/_admin/prompt-templates/")({
  beforeLoad: () => {
    throw redirect({ to: "/prompt-engine/templates", replace: true });
  },
  component: () => null,
});
